import LoadingLogo from "../assets/images/logo2.png";

export default function LoadingPage() {
    return (
        <div className='flex bg-gray-100 dark:bg-[#171717] h-screen w-screen items-center justify-center'>
            {/* Animated Background */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-1/4 -left-10 w-80 h-80 bg-sky-400/20 rounded-full blur-3xl animate-float-slow"></div>
                <div className="absolute bottom-1/4 -right-10 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-float-medium"></div>
                <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-emerald-400/15 rounded-full blur-3xl animate-float-fast"></div>
            </div>
            <div className="w-[30%] md:w-[8%]">
                <img className="animate-bounce" src={LoadingLogo} alt="loading" />
                {/* <Lottie
                    animationData={LogoSampang}
                    loop={true}
                /> */}
            </div>
        </div>
    )
}